import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";

export const getStructuredDataList = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/business/@me/structured-data", {
      headers: { Authorization: `Bearer ${accessToken}` },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.error || error?.message || "مشکل شبکه یا عدم دسترسی به سرور.");
  }
};

export const getStructuredDataProcess = async ({ accessToken, fileId }) => {
  try {
    const response = await axiosInstance.get(
      `/business/@me/structured-data/${fileId}/process`,
      { headers: { Authorization: `Bearer ${accessToken}` }, withCredentials: true }
    );
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.error || error?.message || "مشکل شبکه یا عدم دسترسی به سرور.");
  }
};

export const confirmStructuredData = async ({ accessToken, fileId }) => {
  try {
    const response = await axiosInstance.post(
      `/business/@me/structured-data/${fileId}/confirm`,
      {},
      { headers: { Authorization: `Bearer ${accessToken}` }, withCredentials: true }
    );
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.error || error?.message || "مشکل شبکه یا عدم دسترسی به سرور.");
  }
};
export const deleteStructuredData = async ({ accessToken, fileId }) => {
  try {
    const response = await axiosInstance.delete(`/business/@me/structured-data/${fileId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
